module.exports = __webpack_public_path__ + "static/media/hail.svg.cc907c35.png";